const ITEMS = ["MOPAR PERFORMANCE", "MOPAR OR NO CAR"];

const Group = ({ hidden }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {[0, 1, 2].map((n) => (
      <span key={n} className="flex items-center">
        {ITEMS.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center">
            <span className="px-6 font-display text-4xl font-bold uppercase tracking-[0.02em] text-white sm:px-10 sm:text-6xl">
              {item}
            </span>
            <span className="h-2.5 w-2.5 rotate-45 bg-bone/80 sm:h-3 sm:w-3" />
          </span>
        ))}
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div className="overflow-hidden border-y border-bone/10 bg-navy py-5 sm:py-7">
      <div className="animate-marquee flex w-max">
        <Group />
        <Group hidden />
      </div>
    </div>
  );
}
